export default function handlerLoading<T extends React.Component<{}, { loadingKey?: any }>>(
    this: T,
    loadingKey: unknown,
    props: { [s: string]: any } = {},
): Promise<void> {
    return new Promise((resolve) => {
        this.setState({ loadingKey, ...props }, resolve);
    });
}
